import {
  CLARK_USER_PREFERENCE_DEFINITIONS,
  type ClarkUserPreferenceVisibility,
} from "core/clark/user-preferences/preferences";
import { Flag } from "store/slices/featureFlags";

import { useFeatureFlag } from "./useFeatureFlag";

/**
 * Dashboard-side adapter that resolves Clark preference visibility from
 * feature flags. Mirrors the app hook of the same name so callsites read
 * identically. When adding a new Clark preference, add a `useFeatureFlag`
 * call here and in the app counterpart.
 */
export const useClarkUserPreferenceVisibility =
  (): ClarkUserPreferenceVisibility => {
    // Cast: `featureFlagId` is typed as `string` in core (kept free of the
    // surface `Flag` enum). It's always a real `Flag` value at runtime.
    // The return is coerced because casting through the wide `Flag` union
    // widens `useFeatureFlag`'s conditional return.
    const suggestNextSteps = Boolean(
      useFeatureFlag(
        CLARK_USER_PREFERENCE_DEFINITIONS.suggestNextSteps
          .featureFlagId as Flag,
      ),
    );

    return {
      suggestNextSteps,
    };
  };
